import React from 'react';

import PageCard from '../../PageCard';
import { getImagePath } from '../../../utils';

const alertSVG = getImagePath('ic_alert.svg');

const NoQueryParams = () => (
  <PageCard className="NoQueryParams">
    <img src={alertSVG} alt="warning" />

    <span>
      Error: Parameters 'country', 'language' and 'cp' are required.
    </span>
  </PageCard>
);

export default NoQueryParams;
